import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { SourceIncome } from '../../../../../core';

@JsonConverter
export class SourceIncomeAdapter implements JsonCustomConvert<SourceIncome[] | undefined> {
    serialize(sources: SourceIncome[]): any | undefined {
        const serializedSources = [];

        if (!!sources) {
            sources.map((source) => serializedSources.push(String(source)));
        }

        return serializedSources;
    }

    deserialize(sources: any): SourceIncome[] | undefined {
        const unserializedSources = [];

        if (sources && Array.isArray(sources)) {
            sources.map((source) => {
                switch (source) {
                    case 'RT':
                        unserializedSources.push(SourceIncome.WORK);
                        break;
                    case 'RC':
                        unserializedSources.push(SourceIncome.CAPITAL_RENTS);
                        break;
                    case 'SN':
                        unserializedSources.push(SourceIncome.NONE);
                        break;
                    case 'PP':
                        unserializedSources.push(SourceIncome.PUBLIC_BENEFITS);
                        break;
                    case 'RJ':
                        unserializedSources.push(SourceIncome.PENSION);
                        break;
                    case 'TR':
                        unserializedSources.push(SourceIncome.OTHER);
                        break;
                }
            });
        }

        return unserializedSources;
    }
}
